'use strict';

var jsxRuntime = require('react/jsx-runtime');
var WebDevelopment = require('./Icons/WebDevelopment.js');
var WebDomain = require('./Icons/WebDomain.js');
var WebSecurity = require('./Icons/WebSecurity.js');
var WebPayment = require('./Icons/WebPayment.js');
var WidePaperStructure = require('./Icons/WidePaperStructure.js');
var WidePaperPlan = require('./Icons/WidePaperPlan.js');
var WidePaperPayment = require('./Icons/WidePaperPayment.js');
var WidePaperConfirm = require('./Icons/WidePaperConfirm.js');
var PaperProject = require('./Icons/PaperProject.js');
var PaperContract = require('./Icons/PaperContract.js');
var PaperCertify = require('./Icons/PaperCertify.js');
var PaperSecurity = require('./Icons/PaperSecurity.js');
var PaperClock = require('./Icons/PaperClock.js');
var PaperConfirm = require('./Icons/PaperConfirm.js');
var PaperClip = require('./Icons/PaperClip.js');
var PaperOverlap = require('./Icons/PaperOverlap.js');
var PaperHold = require('./Icons/PaperHold.js');
var MemoWrite = require('./Icons/MemoWrite.js');
var Receipt = require('./Icons/Receipt.js');
var DocumentSuccess = require('./Icons/DocumentSuccess.js');
var DocumentCloud = require('./Icons/DocumentCloud.js');
var PersonFreelancer = require('./Icons/PersonFreelancer.js');
var PersonOffice = require('./Icons/PersonOffice.js');
var PersonSmile = require('./Icons/PersonSmile.js');
var Building = require('./Icons/Building.js');
var HandShake = require('./Icons/HandShake.js');
var HandThumb = require('./Icons/HandThumb.js');
var Search = require('./Icons/Search.js');
var SearchConfirm = require('./Icons/SearchConfirm.js');
var Design = require('./Icons/Design.js');
var Repair = require('./Icons/Repair.js');
var CardConfirm = require('./Icons/CardConfirm.js');
var CardWrite = require('./Icons/CardWrite.js');
var Bookmark = require('./Icons/Bookmark.js');
var Idea = require('./Icons/Idea.js');
var MobileConfirm = require('./Icons/MobileConfirm.js');
var Database = require('./Icons/Database.js');
var Email = require('./Icons/Email.js');
var Credit = require('./Icons/Credit.js');
var ShieldConfirm = require('./Icons/ShieldConfirm.js');
var ShieldWon = require('./Icons/ShieldWon.js');
var Shopping = require('./Icons/Shopping.js');
var BubbleStar = require('./Icons/BubbleStar.js');
var BubbleStars = require('./Icons/BubbleStars.js');
var Calendar = require('./Icons/Calendar.js');
var Lock = require('./Icons/Lock.js');
var Logout = require('./Icons/Logout.js');
var Congrats = require('./Icons/Congrats.js');
var Discount = require('./Icons/Discount.js');
var PersonOfficeConfirm = require('./Icons/PersonOfficeConfirm.js');
var PaperPaymentConfirm = require('./Icons/PaperPaymentConfirm.js');
var Won = require('./Icons/Won.js');
var Connect = require('./Icons/Connect.js');
var Security = require('./Icons/Security.js');
var Service = require('./Icons/Service.js');
var Download = require('./Icons/Download.js');
var Waiting = require('./Icons/Waiting.js');
var Achieve = require('./Icons/Achieve.js');
var ContractPen = require('./Icons/ContractPen.js');
var Package = require('./Icons/Package.js');
var PaperClipClock = require('./Icons/PaperClipClock.js');
var PaperPen = require('./Icons/PaperPen.js');
var Public = require('./Icons/Public.js');
var BubblePerson = require('./Icons/BubblePerson.js');
var Write = require('./Icons/Write.js');

const SmallProductIconNames = [
    'bookmark',
    'download',
    'waiting',
    'search',
    'contract_pen',
    'paper_pen',
    'paper_confirm',
    'won',
    'package'
];
const MediumProductIconNames = [
    'person_smile',
    'lock',
    'logout',
    'contract_pen',
    'paper_pen',
    'paper_hold',
    'person_office_confirm',
    'paper_payment_confirm',
    'search',
    'search_confirm',
    'won',
    'connect',
    'security',
    'service',
    'package',
    'bubble_person',
    'write'
];
const LargeProductIconNames = [
    'web_development',
    'web_domain',
    'web_security',
    'web_payment',
    'wide_paper_structure',
    'wide_paper_plan',
    'wide_paper_payment',
    'wide_paper_confirm',
    'paper_project',
    'paper_contract',
    'paper_certify',
    'paper_security',
    'paper_clock',
    'paper_confirm',
    'paper_clip',
    'paper_clip_clock',
    'paper_overlap',
    'paper_hold',
    'memo_write',
    'receipt',
    'document_success',
    'document_cloud',
    'person_freelancer',
    'person_office',
    'person_smile',
    'building',
    'hand_shake',
    'hand_thumb',
    'search',
    'search_confirm',
    'design',
    'repair',
    'card_confirm',
    'card_write',
    'bookmark',
    'idea',
    'mobile_confirm',
    'database',
    'email',
    'credit',
    'shield_confirm',
    'shield_won',
    'shopping',
    'bubble_star',
    'bubble_stars',
    'calendar',
    'public',
    'lock',
    'logout',
    'congrats',
    'discount',
    'achieve'
];
const productIcons = new Map([
    [
        'web_development',
        (props)=>jsxRuntime.jsx(WebDevelopment, Object.assign({}, props))
    ],
    [
        'web_domain',
        (props)=>jsxRuntime.jsx(WebDomain, Object.assign({}, props))
    ],
    [
        'web_security',
        (props)=>jsxRuntime.jsx(WebSecurity, Object.assign({}, props))
    ],
    [
        'web_payment',
        (props)=>jsxRuntime.jsx(WebPayment, Object.assign({}, props))
    ],
    [
        'wide_paper_structure',
        (props)=>jsxRuntime.jsx(WidePaperStructure, Object.assign({}, props))
    ],
    [
        'wide_paper_plan',
        (props)=>jsxRuntime.jsx(WidePaperPlan, Object.assign({}, props))
    ],
    [
        'wide_paper_payment',
        (props)=>jsxRuntime.jsx(WidePaperPayment, Object.assign({}, props))
    ],
    [
        'wide_paper_confirm',
        (props)=>jsxRuntime.jsx(WidePaperConfirm, Object.assign({}, props))
    ],
    [
        'paper_project',
        (props)=>jsxRuntime.jsx(PaperProject, Object.assign({}, props))
    ],
    [
        'paper_contract',
        (props)=>jsxRuntime.jsx(PaperContract, Object.assign({}, props))
    ],
    [
        'paper_certify',
        (props)=>jsxRuntime.jsx(PaperCertify, Object.assign({}, props))
    ],
    [
        'paper_security',
        (props)=>jsxRuntime.jsx(PaperSecurity, Object.assign({}, props))
    ],
    [
        'paper_clock',
        (props)=>jsxRuntime.jsx(PaperClock, Object.assign({}, props))
    ],
    [
        'paper_confirm',
        (props)=>jsxRuntime.jsx(PaperConfirm, Object.assign({}, props))
    ],
    [
        'paper_clip',
        (props)=>jsxRuntime.jsx(PaperClip, Object.assign({}, props))
    ],
    [
        'paper_overlap',
        (props)=>jsxRuntime.jsx(PaperOverlap, Object.assign({}, props))
    ],
    [
        'paper_hold',
        (props)=>jsxRuntime.jsx(PaperHold, Object.assign({}, props))
    ],
    [
        'memo_write',
        (props)=>jsxRuntime.jsx(MemoWrite, Object.assign({}, props))
    ],
    [
        'receipt',
        (props)=>jsxRuntime.jsx(Receipt, Object.assign({}, props))
    ],
    [
        'document_success',
        (props)=>jsxRuntime.jsx(DocumentSuccess, Object.assign({}, props))
    ],
    [
        'document_cloud',
        (props)=>jsxRuntime.jsx(DocumentCloud, Object.assign({}, props))
    ],
    [
        'person_freelancer',
        (props)=>jsxRuntime.jsx(PersonFreelancer, Object.assign({}, props))
    ],
    [
        'person_office',
        (props)=>jsxRuntime.jsx(PersonOffice, Object.assign({}, props))
    ],
    [
        'person_smile',
        (props)=>jsxRuntime.jsx(PersonSmile, Object.assign({}, props))
    ],
    [
        'building',
        (props)=>jsxRuntime.jsx(Building, Object.assign({}, props))
    ],
    [
        'hand_shake',
        (props)=>jsxRuntime.jsx(HandShake, Object.assign({}, props))
    ],
    [
        'hand_thumb',
        (props)=>jsxRuntime.jsx(HandThumb, Object.assign({}, props))
    ],
    [
        'search',
        (props)=>jsxRuntime.jsx(Search, Object.assign({}, props))
    ],
    [
        'search_confirm',
        (props)=>jsxRuntime.jsx(SearchConfirm, Object.assign({}, props))
    ],
    [
        'design',
        (props)=>jsxRuntime.jsx(Design, Object.assign({}, props))
    ],
    [
        'repair',
        (props)=>jsxRuntime.jsx(Repair, Object.assign({}, props))
    ],
    [
        'card_confirm',
        (props)=>jsxRuntime.jsx(CardConfirm, Object.assign({}, props))
    ],
    [
        'card_write',
        (props)=>jsxRuntime.jsx(CardWrite, Object.assign({}, props))
    ],
    [
        'bookmark',
        (props)=>jsxRuntime.jsx(Bookmark, Object.assign({}, props))
    ],
    [
        'idea',
        (props)=>jsxRuntime.jsx(Idea, Object.assign({}, props))
    ],
    [
        'mobile_confirm',
        (props)=>jsxRuntime.jsx(MobileConfirm, Object.assign({}, props))
    ],
    [
        'database',
        (props)=>jsxRuntime.jsx(Database, Object.assign({}, props))
    ],
    [
        'email',
        (props)=>jsxRuntime.jsx(Email, Object.assign({}, props))
    ],
    [
        'credit',
        (props)=>jsxRuntime.jsx(Credit, Object.assign({}, props))
    ],
    [
        'shield_confirm',
        (props)=>jsxRuntime.jsx(ShieldConfirm, Object.assign({}, props))
    ],
    [
        'shield_won',
        (props)=>jsxRuntime.jsx(ShieldWon, Object.assign({}, props))
    ],
    [
        'shopping',
        (props)=>jsxRuntime.jsx(Shopping, Object.assign({}, props))
    ],
    [
        'bubble_star',
        (props)=>jsxRuntime.jsx(BubbleStar, Object.assign({}, props))
    ],
    [
        'bubble_stars',
        (props)=>jsxRuntime.jsx(BubbleStars, Object.assign({}, props))
    ],
    [
        'calendar',
        (props)=>jsxRuntime.jsx(Calendar, Object.assign({}, props))
    ],
    [
        'lock',
        (props)=>jsxRuntime.jsx(Lock, Object.assign({}, props))
    ],
    [
        'logout',
        (props)=>jsxRuntime.jsx(Logout, Object.assign({}, props))
    ],
    [
        'congrats',
        (props)=>jsxRuntime.jsx(Congrats, Object.assign({}, props))
    ],
    [
        'discount',
        (props)=>jsxRuntime.jsx(Discount, Object.assign({}, props))
    ],
    [
        'person_office_confirm',
        ()=>jsxRuntime.jsx(PersonOfficeConfirm, {})
    ],
    [
        'paper_payment_confirm',
        ()=>jsxRuntime.jsx(PaperPaymentConfirm, {})
    ],
    [
        'won',
        (props)=>jsxRuntime.jsx(Won, Object.assign({}, props))
    ],
    [
        'connect',
        ()=>jsxRuntime.jsx(Connect, {})
    ],
    [
        'security',
        ()=>jsxRuntime.jsx(Security, {})
    ],
    [
        'service',
        ()=>jsxRuntime.jsx(Service, {})
    ],
    [
        'download',
        ()=>jsxRuntime.jsx(Download, {})
    ],
    [
        'waiting',
        ()=>jsxRuntime.jsx(Waiting, {})
    ],
    [
        'achieve',
        (props)=>jsxRuntime.jsx(Achieve, Object.assign({}, props))
    ],
    [
        'contract_pen',
        (props)=>jsxRuntime.jsx(ContractPen, Object.assign({}, props))
    ],
    [
        'package',
        (props)=>jsxRuntime.jsx(Package, Object.assign({}, props))
    ],
    [
        'paper_clip_clock',
        (props)=>jsxRuntime.jsx(PaperClipClock, Object.assign({}, props))
    ],
    [
        'paper_pen',
        (props)=>jsxRuntime.jsx(PaperPen, Object.assign({}, props))
    ],
    [
        'public',
        (props)=>jsxRuntime.jsx(Public, Object.assign({}, props))
    ],
    [
        'bubble_person',
        ()=>jsxRuntime.jsx(BubblePerson, {})
    ],
    [
        'write',
        ()=>jsxRuntime.jsx(Write, {})
    ]
]);

exports.LargeProductIconNames = LargeProductIconNames;
exports.MediumProductIconNames = MediumProductIconNames;
exports.SmallProductIconNames = SmallProductIconNames;
exports.productIcons = productIcons;
